<template>
  <div class="warningInfo" v-if="show">
    <div class="title">Наш сервис прекращает работу</div>
    <div class="text">
      Дорогие пользователи, с 1 октября 2023 года наш сервис перестаёт работать.
      <br>
      Карты, FindGuest и сервисы коротких ссылок и QR-кодов будут недоступны.
      <br>
      Оплата больше не принимается.
      <hr>
      Данные Ваших гостей остаются в POS-системах (IIKO, QuickResto, RKeeper), их можно использовать для интеграции с
      новой системой лояльности.
      <br>
      Карты лояльности предоставляют:
      <br>
      <a href="https://ru.cardpr.com/" target="_blank">CardPR</a>,
      <a href="https://osmicards.com/karty-wallet/" target="_blank">OsmiCards</a>,
      <a href="https://ru.iiko.help/articles/#!iikocard/iikowallet/a/h3_133716111" target="_blank">IIKO</a>.
    </div>
    <div class="buttons">
      <button @click="okay">Понятно</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  updated() {
  },
  methods: {
    okay() {
      this.show = false;
    },
  },
  mounted: function () {
    console.log("mounted");
    let userId = 0;
    if (this.$store.state.userData) {
      if (this.$store.state.userData.user) {
        userId = this.$store.state.userData.user.id;
      }
    }

    if (userId != 0) {
      let dontDisplayTo = [27, 48, 2];
      if (dontDisplayTo.indexOf(userId) == -1) {
        this.show = true;
      }
    }
  },
}
</script>

<style lang="stylus">
.warningInfo{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 300;
  text-align: center;
  background: #000000d9;
  z-index: 9999;
  padding: 0 20px;

  .title{
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .text{
    margin-bottom: 20px;
  }
  .buttons{
    button{
      background: #fff;
      border: none;
      border-radius: 4px;
      padding: 10px 20px;
      font-size: 18px;
      font-weight: 500;
      cursor: pointer;
      &:hover{
        background: #eee;
      }
    }
  }
}
</style>